var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.jwt && _vm.userData.isAdmin)?_c('v-card',{staticStyle:{"background-color":"transparent"},attrs:{"flat":""}},[_c('Menu'),_c('v-content',[_c('router-view')],1)],1):_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }